import {connect} from 'react-redux';
import compose from 'recompose/compose';
import withState from 'recompose/withState';
import lifecycle from 'recompose/lifecycle';
import withHandlers from 'recompose/withHandlers';
import * as RouteUtils from '../../../routes/utils';
import Layout from './layout';

function mapStateToProps(state) {
	const {page: {title} = {}} = state;

	return {
		title
	};
}

const enhance = compose(
	connect(mapStateToProps),
	withState('isHomepage', 'updateIsHomepage', false),
	lifecycle({
		componentDidMount() {
			const {props: {location: {pathname}, updateIsHomepage}} = this;

			updateIsHomepage(RouteUtils.isMainHomepage(pathname));
		},
		componentWillReceiveProps(nextProps) {
			const {props: {location: {pathname}, updateIsHomepage}} = this;
			const {location: {pathname: newPath}} = nextProps;

			if (pathname !== newPath) {
				updateIsHomepage(RouteUtils.isMainHomepage(newPath));
			}
		}
	}),
	withHandlers({
		handleGoBack: props => () => {
			const {location: {pathname}, history} = props;
			const route = RouteUtils.getMainRoute(pathname);

			switch (route) {
				case RouteUtils.MAIN_LIST_FILES:
					history.push('/');
					break;
				case RouteUtils.MAIN_VIEW_FILE:
					history.push(pathname.replace(/\/video\/[^/]+\/?$/, '/files'));
					break;
				default:
					if (history.length === 1) {
						history.push('/');
					} else {
						history.goBack();
					}
			}
		}
	})
);

export default enhance(Layout);




// WEBPACK FOOTER //
// ./src/client/components/main/layout/index.js